<template>
  <el-icon
    class="svg-icon custom-el-icon"
    v-if="iconFlag"
    :style="{
      color: fillColor,
    }"
  >
    <component
      :is="props.iconName.replace('el-', '')" 
    />
  </el-icon>
  <svg
    class="svg-icon"
    :style="{
      fill: fillColor,
      '--fillColor': fillColor,
      color: fillColor,
    }"
    v-else
  >
    <use :xlink:href="'#icon-'+iconName"></use>
  </svg>

</template>

<script setup>
import {
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick
} from 'vue';
import { isNull, dayjs, message } from '@/utils/js/initVariable';
import { ElIcon } from 'element-plus';

// props
const props = defineProps({
  iconName: { type: String, required: true, },
  fillColor: { type: String, },
});
// emit
const emit = defineEmits([

]);

const iconFlag = computed(()=>{
  return props.iconName.indexOf('el-') == 0;
})

// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{

});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{

});

</script>

<style lang='less'>

</style>

<style lang='less' scoped>
.svg-icon {
  width: var(--svgIconDefaultSize);
  height: var(--svgIconDefaultSize);;
  font-size: var(--svgIconDefaultSize);;
  vertical-align: -0.15em;
  overflow: hidden;
  transition: all 0.3s;
  g{
    stroke: var(--fillColor);
  }
}
</style>